import { api, clearAuth, persistAuth } from "@/api/client";
import type { AuthMe, AuthTokens, UpdateProfileInput } from "@/types/api";

export async function login(
  email: string,
  password: string,
): Promise<AuthTokens> {
  const data = await api<AuthTokens>("/auth/login", {
    method: "POST",
    body: JSON.stringify({ email, password }),
    skipAuth: true,
  });
  persistAuth(data);
  return data;
}

export async function register(input: {
  email: string;
  password: string;
  displayName?: string;
  fullName?: string;
  locale?: string;
}): Promise<{ userId: string; email: string }> {
  return api("/auth/register", {
    method: "POST",
    body: JSON.stringify(input),
    skipAuth: true,
  });
}

export async function getMe(): Promise<AuthMe> {
  return api<AuthMe>("/auth/me");
}

export async function updateProfile(
  input: UpdateProfileInput,
): Promise<AuthMe> {
  return api<AuthMe>("/auth/me", {
    method: "PATCH",
    body: JSON.stringify(input),
  });
}

export function logout(): void {
  clearAuth();
}
